export default __webpack_public_path__ + "static/media/nightmarethumb.b7488eef.png";